<template>
  <div class="container">
    <span class="title is-3">{{empresa.nombrec}}</span>
    <small class="title is-5">{{empresa.nit | textnumber()}}{{empresa.nit | dverif()}}</small>
    <small class="subtitle is-7">{{empresa.nombre}}</small>
    <hr />
    <div style="margin-top: 32px; margin-bottom:32px;">
      <button class="button is-medium is-light" v-on:click="showList">Lista</button>
      <button class="button is-medium is-light" v-on:click="createPeriod">Crear</button>
    </div>
    <div>
      <p class="title">{{title}}</p>
      <div class="table-container" v-if="showCreate==false">
        <table class="table is-hoverable is-fullwidth">
          <thead>
            <tr>
              <th>Año</th>
              <th>Nombre</th>
              <th>Código</th>
              <th>Est</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(month, index) in dataMonths" :key="index">
              <th>{{month.year}}</th>
              <td>{{month.nombre}}</td>
              <td>{{month.codigo}}</td>
              <td>
                <span class="icon has-text-info hand" v-if="month.abierto">
                  <i class="material-icons">folder_open</i>
                </span>
                <span class="icon has-text-info hand" v-else>
                  <i class="material-icons">folder</i>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="columns is-fullwidth" v-if="showCreate==true">
        <div class="column">
          <p class="title is-5">Periodo</p>
          <div class="select is-medium is-fullwidth">
            <select>
              <option>Selecciona un periodo</option>
              <option v-for="(option, key) in dataMonths" v-bind:value="option" v-bind:key="key">{{option.nombre}} de {{option.year}}</option>
            </select>
          </div>
          <div class="buttons" style="margin-top:16px;">
            <button @click="saveCCosto" class="button is-info is-medium">
              <span class="material-icons">save</span>Guardar
            </button>
            <button class="button is-medium" v-on:click="showList">Cancelar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  created() {
    this.getMonths();
  },
  computed: {
    ...mapState(["empresa"]),
  },
  data() {
    return {
      title: "Meses",
      dataMonths: [],
      showCreate: false,
    };
  },
  methods: {
    showList(){
      this.showCreate = false;
      this.title = "Meses"
    },
    createPeriod() {
      this.showCreate = true;
      this.title = "Crear periodo contable";
    },
    async getMonths() {
      try {
        const result = await apiServices.get(`/meses`);
        console.log("result messs: ", result);
        result.data.forEach((element) => {
          this.dataMonths.push(element);
        });
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/configurations/months/Months.vue